<template>
    <!-- <el-container style="height:100%;background:#A8A8A8;">
        <div id="china_map" ref="ChinaEchart" style="width: 100%; height: 100%;"></div>
    </el-container> -->
    <div style="height:100%">
        <div id="china_map" ref="ChinaEchart" style="width: 100%; background:#A8A8A8;"></div>
        <div class="info">
            <div class="left-ball"></div>
            <div class="right-ball"></div>
            <div class="title">{{$t('warehouse1.title1')}}</div>
            <div class="card-box"  v-if="$i18n.locale == 'zh'">
                <div class="item" v-for="(item,index) in dataList" :key="index" v-if="item.content">
                    <img :src="dataList[index].image">
                    <div style="font-size:22px;margin-bottom:10px">{{dataList[index].name}}</div>
                    <div style="display: flex">
                        <img src="../../assets/images/icon-jian.png" style="width:19px;height:19px;margin-right:16px;margin-top:3px">
                        <div v-html="dataList[index].content" style="font-size:18px;"></div>
                    </div>
                </div>
            </div>
            <div class="card-box" v-if="$i18n.locale == 'en'">
                <div class="item" v-for="(item,index) in dataList" :key="index" v-if="item.content">
                    <img :src="dataList[index].image">
                    <div style="font-size:20px;font-family:'Lato-Bold';margin-bottom:10px">{{dataList[index].enName}}</div>
                    <div style="display: flex">
                        <img src="../../assets/images/icon-jian.png" style="width:19px;height:19px;margin-right:16px;margin-top:3px">
                        <div v-html="dataList[index].enContent" style="font-size:18px;font-family:'Lato'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts"
import '../../../node_modules/echarts/map/js/china.js' //引入中国地图
export default ({
    watch:{
        '$i18n.locale':function(newLang,oldLang){
            this.lang = newLang
            this.initMap()
        }
    },
    data() {
        return {
        lang: 'zh',
            //echart 配制option  
        options:{},
        dataList: [
        {
            name: "上海",
            enName: "Shanghai",
            label: {
                normal: {
                    position: 'right',
                    offset: [-2,0]
                }
            },
            value: [121.504642,31.24186],
            content: '丙2类 55,000+m²<br>(共3个库)',
            enContent: 'C2 Warehouse 55,000+m²<br>(Three in total)',
            image: require("../../assets/images/shanghaipu1.png")
        },
        {
            name: "宁波",
            enName: "Ningbo",
            label: {
                normal: {
                    position: 'bottom',
                    offset:[0,-10]
                }
            },
            value: [121.541732,29.870328],
            content: "丙2类 1,250m²",
            enContent: "C2 Warehouse 1,250m²",
            image: require("../../assets/images/ningbopu.png")
        },
        // {
        //     name: "郑州",
        //     enName: "Zhengzhou",
        //     label: {
        //         normal: {
        //             position: 'bottom',
        //             offset:[0,-10]
        //         }
        //     },
        //     value: [113.648996,34.737249],
        //     content: "1,450 m²",
        //     enContent: "1,450 m²",
        //     image: require("../../assets/images/zhengzhoupu1.png")
        // },
        {
            name: "武汉",
            enName: "Wuhan",
            label: {
                normal: {
                    position: 'bottom',
                    offset:[0,-10]
                }
            },            
            value: [114.338531,30.558876],
            content: "丙1类 8,000m²",
            enContent: "C1 Warehouse 8,000m²",
            image: require("../../assets/images/wuhanpu1.png")
        },
        {
            name: "天津",
            enName: "Tianjin",
            value: [117.220915,39.116983],
            label: {
                normal: {
                    position: 'top',
                    offset: [0,10]
                }
            },
            content: "丙1类 5,000m²",
            enContent: "C1 Warehouse 5,000m²",
            image: require("../../assets/images/tianjinpu.png")
        },
        // {
        //     name: "济南",
        //     enName: "Jinan",
        //     value: [117.112117,36.64872],
        //     label: {
        //         normal: {
        //             position: 'right',
        //             offset: [-10,0]
        //         }
        //     },
        // },
        // {
        //     name: "西安",
        //     enName: "Xi'an",
        //     label: {
        //         normal: {
        //             position: 'bottom',
        //             offset:[0,-10]
        //         }
        //     },
        //     value: [108.94903,34.342049]
        // },
        {
            name: "张家港",
            enName: "Zhangjiagang",
            value: [120.520216,31.856251],
            label: {
                normal: {
                    position: 'top',
                    offset: [0,10]
                }
            },
            content: "丙1类 14,000m²<br>丙2类 30,000m²",
            enContent: "C1 Warehouse 14,000m²<br>C2 Warehouse 30,000m²",
            image: require("../../assets/images/zhangjiagangpu.png")
        },
        {
            name: "乌鲁木齐",
            enName: "Urumqi",
            label: {
                normal: {
                    position: 'top',
                    offset: [0,10]
                }
            },
            value: [87.580026,43.763089],
            content: "丙2类 1,400+m²",
            enContent: "C2 Warehouse 1,400+m²",
            image: require("../../assets/images/wulumuqipu1.png")
        },
        // {
        //     name: "重庆",
        //     enName: "Chongqing",
        //     label: {
        //         normal: {
        //             position: 'bottom',
        //             offset:[0,-10]
        //         }
        //     },            
        //     value: [106.487678,29.541249]
        // },
        // {
        //     name: "广州",
        //     enName: "Guangzhou",
        //     value: [113.249398,23.015992],
        //     label: {
        //         normal: {
        //             position: 'top',
        //             offset: [0,10]
        //         }
        //     }
        // }
        ]
        }
    },
    created() {
        this.lang = this.$i18n.locale
        this.setEchartOption()
    },
    mounted: function () {
        // this.ByStaticJson()//通过post请求方式读取json文件，但要求json文件必须在vue工程下的static文件夹
        this.$nextTick(()=>{
            this.initMap()
        })    
    },
    methods: {
        initMap(){
            let mapDiv = document.getElementById('china_map')
            let myChart = echarts.init(mapDiv)
            myChart.setOption(this.options)
        },
            //修改echart配制
        setEchartOption(){
            const _this = this
            this.options = {
                tooltip: {
                    triggerOn: "mousemove",   //mousemove、click
                    backgroundColor:'transparent',
                    borderRadius: 4,
                    trigger: 'item',
                　　// 相对位置
                    // 　　position: ['0%', '0%'],
                    textStyle:{
                        color:'#000000',
                        fontSize:20
                    },
                    formatter: function(e, t, n) {
                        if(!e.data || !e.data.content){
                            return ''
                        } else{
                            let data = e.data
                            if(_this.lang == 'zh'){
                                let context = `
                                <div class="tool-box">
                                    <div style="font-size:24px;line-height:24px;">${data.name}</div>
                                    <div class="map_content">
                                        <div class="map_left">
                                            <div class="map_title">面积:</div>
                                            <div class="map_item">${data.content}</div>
                                        </div>
                                        <div class="map_img">
                                            <img style="width: 163px;" src="`+ data.image +`">
                                        </div>
                                    </div>    
                                </div>
                                `
                                return context
                            }else if(_this.lang == 'en'){
                                let context = `
                                <div class="tool-box">
                                    <div style="font-size:24px;line-height:24px;">${data.enName}</div>
                                    <div class="map_content">
                                        <div class="map_left">
                                            <div class="map_title">Area：</div>
                                            <div class="map_item">${data.enContent}</div>
                                        </div>
                                        <div class="map_img">
                                            <img style="width: 163px;" src="`+ data.image +`">
                                        </div>
                                    </div>    
                                </div>
                                `
                                return context
                            }
                        }
                    }
                },
  
                geo: {
                    map: "china",
                    zoom: 2,
                    top: -10,
                    roam: true, //是否开启平游或缩放
                    scaleLimit: { //滚轮缩放的极限控制
                        min: 1,
                        max: 5
                    },
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#ffffff",
                            borderColor: "rgba(0, 0, 0, 0.2)"
                        },
                        emphasis: {
                            areaColor: "#ffffff",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [{
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    data: this.dataList,
                    // symbol:'circle',
                    symbol: 'image://'+ require('@/assets/images/location1.svg'),
                    symbolSize: [15, 20],
                    label: {
                        normal: {
                            show: true,
                            formatter: function (params) {
                                if(_this.lang == 'zh'){
                                    return params.data.name
                                } else if(_this.lang == 'en'){
                                    return params.data.enName 
                                }
                            },
                            position: 'bottom',
                            color: '#ED6D00',
                            fontSize: '18',
                        }
                    },
                    itemStyle: {
                        color: '#ED6D00'
                    }
                }]
            }
            this.options.series[0]['data'] = this.dataList;
        }
    }
})
</script>
<style>
    #china_map{
        height: 320px;
    }
    @media screen and (max-width: 1399px) {
        #china_map {
            height: 320px;
        }
    }
    #china_map .tool-box{
        width: 381px;
        padding: 16px;
        background: #ffffff;
        color: #4C4948;
        border-radius: 4px;
        box-shadow: 0px 0px 8px 0px rgba(76, 73, 72, 0.3);
    }
    #china_map .map_title{
        font-size: 20px;
        color: #ED6D00;
        margin-top: 16px;
    }
    #china_map .map_content{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    #china_map .map_item{
        width: 50%;
        color: #707070;
        font-size: 15px;
    }
    #china_map .item_text{
        color: #707070;
    }
    #china_map .map_left{
        width: 144px;
        margin-right: 8px;
    }
    #china_map .map_img{
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
    }
    #china_map .map_img img{
        width: 163px;
        /* height: 144px; */
        border-radius: 6px;
    }
</style>
<style scoped>
    .info{
        padding-left: 50px;
        margin-bottom: 20px;
        position: relative;
    }
    .title{
        font-size: 50px;
        line-height: 50px;
        color: #ED6D00;
        padding: 54px 0 45px 0;
    }
    .card-box{
        display: flex;
        flex-wrap: wrap;
    }
    .item {
        width: 25%;
        margin-right: 30px;
        font-weight: 500;
        margin-bottom: 35px;
        color: #4C4948;
    }
    .left-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
    }
    .right-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
    }
    @media screen and (max-width: 768px) {
        #china_map {
            height: 380px;
        }
        .info{
            padding:0 20px;
        }
        .title{
            font-size: 40px;
        }
        .card-box{
            justify-content: space-between;
        }
        .item {
            width: calc(50% - 10px);
            margin-right: 0px;
            font-weight: 500;
            margin-bottom: 35px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/warehousing1/warehousing1.vue